// frontend/src/firebase.js
import { initializeApp, getApps } from 'firebase/app';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

// Primary app: your existing AUTH project
const authCfg = {
  apiKey:        process.env.REACT_APP_AUTH_API_KEY,
  authDomain:    process.env.REACT_APP_AUTH_AUTH_DOMAIN,
  projectId:     process.env.REACT_APP_AUTH_PROJECT_ID,
  appId:         process.env.REACT_APP_AUTH_APP_ID,
  storageBucket: process.env.REACT_APP_AUTH_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_AUTH_MESSAGING_SENDER_ID,
};

// Debug: Check if auth config is loaded
// eslint-disable-next-line no-console
console.log('[Firebase Debug] Auth Config:', {
  apiKey: authCfg.apiKey ? `${authCfg.apiKey.substring(0, 10)}...` : 'MISSING',
  authDomain: authCfg.authDomain || 'MISSING',
  projectId: authCfg.projectId || 'MISSING',
  appId: authCfg.appId ? `${authCfg.appId.substring(0, 10)}...` : 'MISSING',
});

const apps = getApps();
const authApp = apps.find(a => a.name === '[DEFAULT]') || initializeApp(authCfg);

// Expose Auth from the primary app (keeps your existing Google Sign-In intact)
export const auth = getAuth(authApp);
export const googleProvider = new GoogleAuthProvider();

// Secondary app: CHAT project (ONLY for Realtime Database)
const chatCfg = {
  apiKey:        process.env.REACT_APP_CHAT_API_KEY,
  authDomain:    process.env.REACT_APP_CHAT_AUTH_DOMAIN,
  projectId:     process.env.REACT_APP_CHAT_PROJECT_ID,
  appId:         process.env.REACT_APP_CHAT_APP_ID,
  storageBucket: process.env.REACT_APP_CHAT_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_CHAT_MESSAGING_SENDER_ID,
  databaseURL:   process.env.REACT_APP_CHAT_DATABASE_URL,
};

// Debug: Check if chat config is loaded
// eslint-disable-next-line no-console
console.log('[Firebase Debug] Chat Config:', {
  apiKey: chatCfg.apiKey ? `${chatCfg.apiKey.substring(0, 10)}...` : 'MISSING',
  authDomain: chatCfg.authDomain || 'MISSING',
  projectId: chatCfg.projectId || 'MISSING',
  appId: chatCfg.appId ? `${chatCfg.appId.substring(0, 10)}...` : 'MISSING',
  databaseURL: chatCfg.databaseURL || 'MISSING',
});

// Name the secondary app explicitly so it doesn't collide
const chatApp = apps.find(a => a.name === 'chat') || initializeApp(chatCfg, 'chat');

// Expose RTDB from the secondary app
export const chatDb = getDatabase(chatApp);

// Optional: dev sanity logs
if (process.env.NODE_ENV === 'development') {
  // eslint-disable-next-line no-console
  console.log('[Firebase] auth project:', authCfg.projectId);
  // eslint-disable-next-line no-console
  console.log('[Firebase] chat project / RTDB:', chatCfg.projectId, chatCfg.databaseURL);
}